import { render, staticRenderFns } from "./AutomaticDataUpload.vue?vue&type=template&id=7697df48&scoped=true&"
import script from "./AutomaticDataUpload.vue?vue&type=script&lang=js&"
export * from "./AutomaticDataUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7697df48",
  null
  
)

export default component.exports